import { CssBaseline, ThemeProvider } from "@mui/material";
import FuelCalculator from "./screens/fuel_calculator";
import theme from "./theme/theme";

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <FuelCalculator />
    </ThemeProvider>
  );
};

export default App;
